var _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 50,
    viewBox: "0 0 152 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.119 18.3533C74.6123 18.3533 76.5257 18.9666 77.859 20.1933C79.1923 21.4066 79.859 23.0999 79.859 25.2733C79.859 27.4466 79.2057 29.1666 77.899 30.4333C76.6057 31.6999 74.6257 32.3333 71.959 32.3333H67.179V18.3533H72.119ZM72.279 29.5733C73.7057 29.5733 74.799 29.2133 75.559 28.4933C76.3323 27.7733 76.719 26.7266 76.719 25.3533C76.719 23.9799 76.3323 22.9266 75.559 22.1933C74.799 21.4466 73.6257 21.0733 72.039 21.0733H70.299V29.5733H72.279ZM93.2501 25.2733C93.2501 24.0199 92.8501 22.9533 92.0501 22.0733C91.2501 21.1933 90.2634 20.7533 89.0901 20.7533C87.9301 20.7533 86.9501 21.1933 86.1501 22.0733C85.3501 22.9533 84.9501 24.0199 84.9501 25.2733C84.9501 26.5133 85.3501 27.5733 86.1501 28.4533C86.9501 29.3199 87.9301 29.7533 89.0901 29.7533C90.2634 29.7533 91.2501 29.3199 92.0501 28.4533C92.8501 27.5733 93.2501 26.5133 93.2501 25.2733ZM94.3101 30.4133C92.8967 31.7866 91.1567 32.4733 89.0901 32.4733C87.0234 32.4733 85.2834 31.7866 83.8701 30.4133C82.4567 29.0266 81.7501 27.3066 81.7501 25.2533C81.7501 23.1999 82.4567 21.4866 83.8701 20.1133C85.2834 18.7266 87.0234 18.0333 89.0901 18.0333C91.1567 18.0333 92.8967 18.7266 94.3101 20.1133C95.7234 21.4866 96.4301 23.1999 96.4301 25.2533C96.4301 27.3066 95.7234 29.0266 94.3101 30.4133ZM98.6935 27.6533V24.9933H105.814V27.6533H98.6935ZM108.878 18.3533H111.998V32.3333H108.878V18.3533ZM121.361 21.0533V32.3333H118.241V21.0533H114.281V18.3533H125.321V21.0533H121.361Z",
    fill: "#0B5A79"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.8253,
    height: 32.8253,
    rx: 6,
    transform: "matrix(-0.866667 0.498887 0.866667 0.498887 28.614 14.2478)",
    fill: "#5C99D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32.8253,
    height: 32.8253,
    rx: 6,
    transform: "matrix(-0.866667 0.498887 0.866667 0.498887 28.614 6.2478)",
    fill: "#0275D8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 32.8253,
    height: 32.8253,
    rx: 6,
    transform: "matrix(-0.866667 0.498887 0.866667 0.498887 28.614 -1.7522)",
    fill: "#0B5A79"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.55f66eb30a9cae07da940161dd629fa2.svg";
export { ForwardRef as ReactComponent };